import { Component, Input } from '@angular/core'
import { NgClass } from '@angular/common'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TransactionStatus, StatusStyleMap, StatusConfig } from '../../models'
import { AchStatusConfig, ACH_STATUS_CONFIG } from '../../utils/status-config'

@Component({
    selector: 'ach-status-badge',
    standalone: true,
    imports: [NgClass, MatTooltipModule],
    templateUrl: './status-badge.component.html',
    styleUrl: './status-badge.component.scss',
})
export class StatusBadgeComponent {
    @Input({ required: true }) status!: TransactionStatus

    /** Full AchStatusConfig including icon, tooltip, and color. */
    get statusConfig(): AchStatusConfig {
        return ACH_STATUS_CONFIG[this.status]
    }

    /** Backward-compat getter — returns the legacy StatusConfig shape. */
    get config(): StatusConfig {
        return StatusStyleMap[this.status]
    }
}
